import React, { useEffect } from 'react';
import AppLayout from './components/Layout/AppLayout';
import { useEditorStore } from './stores/editorStore';
import { useSettingsStore } from './stores/settingsStore';
import { useHotkeys } from 'react-hotkeys-hook';

function App() {
  const { createDocument, activeDocument, toggleFullscreen } = useEditorStore();
  const { backgroundStyle, updateSettings } = useSettingsStore();

  useEffect(() => {
    if (!activeDocument) {
      createDocument();
    }
  }, [activeDocument, createDocument]);

  // ESC: 풀스크린 토글
  useHotkeys('escape', () => {
    toggleFullscreen();
  });

  // F11: 브라우저 풀스크린
  useHotkeys('f11', (e) => {
    e.preventDefault();
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen();
    } else {
      document.exitFullscreen();
    }
  });

  // Ctrl+N: 새 문서
  useHotkeys('ctrl+n', (e) => {
    e.preventDefault();
    createDocument();
  });

  // Ctrl+Shift+N: 새 문서 (맥에서)
  useHotkeys('cmd+n', (e) => {
    e.preventDefault();
    createDocument();
  });

  // 🎨 Ctrl+B (또는 Cmd+B): 배경 테마 순환 변경
  useHotkeys(['ctrl+b', 'cmd+b'], (e) => {
    e.preventDefault();
    const backgrounds = ['solid', 'gradient', 'image'];
    const currentIndex = backgrounds.indexOf(backgroundStyle);
    const nextIndex = (currentIndex + 1) % backgrounds.length;
    updateSettings({ backgroundStyle: backgrounds[nextIndex] as any });
  });

  return <AppLayout />;
}

export default App;
